import './styles/contentItem.scss';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon, useTheme } from '../..';
const ContentItem = _ref => {
  let {
    active,
    cover,
    description,
    title
  } = _ref;
  const {
    theme
  } = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-content-item', {
      active
    }, theme)
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-cover",
    style: {
      backgroundImage: `url(${cover})`
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "content-title-block"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "content-title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "content-description"
  }, description)), /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    className: "content-check"
  }));
};
ContentItem.propTypes = {
  active: PropTypes.bool,
  cover: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string
};
export default /*#__PURE__*/memo(ContentItem);